import React from 'react';
import ProjectNameInput from './onboarding/ProjectNameInput';
import DemographicTagEditor from './onboarding/DemographicTagEditor';
import FileDropUploader from './onboarding/FileDropUploader';
import { resolveMediaUrl } from '../services/api';
import { toast } from '../utils/toastBus';

export function ProjectBasics({ 
  project, 
  contextText, 
  setContextText,
  contextFilesText, 
  setContextFilesText,
  contextTags, 
  setContextTags,
  contextUploads, 
  setContextUploads,
  onSaveContext,
  busy = false 
}) {
  const [contextTagInput, setContextTagInput] = React.useState('');

  const handleFileUpload = async (files) => {
    const updated = [];
    for (const file of files) {
      try {
        const api = await import('../services/api');
        const uploadRes = await api.default.uploadFile(file);
        const rel = uploadRes?.item?.url || uploadRes?.path || uploadRes?.url || '';
        if (!rel) continue;
        
        const absolute = rel.startsWith('/uploads/') ? `${resolveMediaUrl(rel)}` : rel;
        updated.push({
          url: rel,
          preview: absolute,
          type: file.type.startsWith('image/') ? 'image' : 'file',
          name: file.name,
          persisted: true
        });
      } catch {
        try {
          toast({ type: 'error', message: 'Upload failed' });
        } catch {}
      }
    }
    
    if (updated.length) {
      setContextUploads(prev => [...updated, ...prev]);
    }
  };

  return (
    <div style={{ display: 'grid', gap: 8, background: '#111827', border: '1px solid #1f2937', borderRadius: 10, padding: 12 }}>
      <div style={{ color: '#f9fafb', fontWeight: 600 }}>Project Basics</div>
      <ProjectNameInput
        value={project?.name || ''}
        onChange={() => {}}
        placeholder="Project name"
        disabled
      />
      <textarea
        value={contextText}
        onChange={(e) => setContextText(e.target.value)}
        rows={4}
        placeholder="Context (one point per line)"
        style={{ background: '#0f1115', color: '#e5e7eb', border: '1px solid #374151', borderRadius: 6, padding: 8 }}
      />
      <textarea
        value={contextFilesText}
        onChange={(e) => setContextFilesText(e.target.value)}
        rows={3}
        placeholder="Context Files (one URL per line)"
        style={{ background: '#0f1115', color: '#e5e7eb', border: '1px solid #374151', borderRadius: 6, padding: 8 }}
      />
      <DemographicTagEditor
        tags={contextTags}
        onChange={setContextTags}
        inputValue={contextTagInput}
        onInputChange={setContextTagInput}
        placeholder="Add context tags (e.g., Holiday, Gen Z)"
        disabled={busy}
      />
      <FileDropUploader
        onFiles={handleFileUpload}
        disabled={busy}
        accept="image/*,application/pdf,audio/*"
        title="Attach briefing files or references"
        buttonLabel=""
      />
      
      {!!contextUploads.length && (
        <div style={{ display: 'grid', gap: 6 }}>
          {contextUploads.map((item, idx) => (
            <div key={`${item.url}-${idx}`} style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <div style={{ color: '#9ca3af', minWidth: 64 }}>{item.type}</div>
              {item.type === 'image' ? (
                <img 
                  src={item.preview || resolveMediaUrl(item.url)} 
                  alt={item.name || 'context upload'} 
                  style={{ height: 48, borderRadius: 6, border: '1px solid #374151' }} 
                />
              ) : (
                <a 
                  href={resolveMediaUrl(item.url)} 
                  target="_blank" 
                  rel="noreferrer" 
                  style={{ color: '#93c5fd', fontSize: 13 }}
                >
                  {item.name || item.url}
                </a>
              )}
              <button
                onClick={() => {
                  setContextUploads((prev) => prev.filter((_, i) => i !== idx));
                }}
                style={{ 
                  marginLeft: 'auto', 
                  background: '#1f2937', 
                  color: '#f87171', 
                  border: 0, 
                  borderRadius: 6, 
                  padding: '4px 8px', 
                  cursor: 'pointer', 
                  fontSize: 12 
                }}
              >
                Remove
              </button>
            </div>
          ))}
        </div>
      )}
      
      <div>
        <button
          onClick={onSaveContext}
          style={{ 
            background: '#2563eb', 
            color: '#fff', 
            border: 0, 
            borderRadius: 8, 
            padding: '6px 10px', 
            cursor: 'pointer' 
          }}
        >
          Save Context
        </button>
      </div>
    </div>
  );
}
